"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
var multi_1 = require("remota-client/module/multi");
var module_1 = require("app/module");
var initialState = {
    // @INJECTION:initial-state
    job: (0, multi_1.initialMultiState)(module_1.OutsideModule.JOB),
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case multi_1.MULTI:
            switch (action.payload.module) {
                // @INJECTION:action
                case module_1.OutsideModule.JOB:
                    return __assign(__assign({}, state), { job: (0, multi_1.multiReducer)(state.job, action.payload) });
                default: {
                    return state;
                }
            }
        default: {
            return state;
        }
    }
}
exports.reducer = reducer;
